// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

import { connect } from 'react-redux';

// @ components
const { CardsView } = require('./cardsView');
const { NerudaUserCardsView } = require('routes/nerudaUserCardsView/nerudaUserCardsView');

class CardsViewWrapper extends React.Component {
    render(){
        if (this.props.isNerudaUser) {
            return <NerudaUserCardsView {...this.props} />
        } else {
            return <CardsView {...this.props} />
        }
    }
}

CardsViewWrapper.propTypes = {
    children: PropTypes.any,
    isNerudaUser: PropTypes.bool,
};

module.exports.constructor = CardsViewWrapper;
module.exports.CardsViewWrapper = connect(state => ({
    isNerudaUser: state.profile.get('isNerudaUser'),
}))(CardsViewWrapper);